import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../api";
import { useAlert } from "react-alert";
import userAction from "../../redux/users/action";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { BeforePayTerms } from "../modals/beforePayTermsModal";
import { TextPopupModal } from "../modals/textPopup";
import trendMeter from "../../images/trendMeter.png";
import arc from "../../images/Arc1.png";
// import { BeforePayTermsBt } from "../modals/beforePayTermsBtModal";

export const Checkout = ({ SubsData }) => {
  const alert = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setUser } = userAction;
  const userStore = useSelector((state) => state.userReducer);
  const [loader, setLoader] = useState(true);
  const [isSubscription, setIsSubscription] = useState(false);
  const [trendData, setTrendData] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [popupText, setPopupText] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const handleClosePopup = () => setShowPopup(false);
  const handleShowPopup = () => setShowPopup(true);

  const [stripeStatus, setStripeStatus] = useState("");

  const onStripePay = async () => {
    try {
      setLoader(true);
      if (!userStore?.users?.user?._id) {
        setLoader(false);
        alert.show("User not found");
        return;
      }
      if (isSubscription) {
        setLoader(false);
        alert.show("Already Subscribed");
        return;
      }
      const userCansubscribe = await checkCanSubscribe();
      // console.log(userCansubscribe);
      if (userCansubscribe?.canSubscribe) {
        const payload = {
          _id: userStore?.users?.user?._id,
          item: 1,
          months: 1,
        };
        const stripeRes = await api.createPayment(payload);

        if (!stripeRes?.link) {
          throw new Error("Something went wrong");
        }

        window.open(stripeRes?.link, "_self");
      } else {
        if (userCansubscribe?.status) {
          if (userCansubscribe?.status.toLowerCase() == "active") {
            setPopupText(
              "YOU ALREADY HAVE ACTIVE SUBSCRIPTION. PLEASE CREATE A TICKET TO CONTACT OUR SUPPORT TEAM."
            );
          } else if (userCansubscribe?.status.toLowerCase() == "past_due")
            setPopupText(
              `YOU ALREADY HAVE A SUBSCRIPTION, YOUR RECURRING PAYMENT IS PENDING.`
            );
        } else {
          setPopupText(`PLEASE CREATE A TICKET TO CONTACT OUR SUPPORT TEAM.`);
        }
        handleShowPopup();
      }
      setLoader(false);
    } catch (e) {
      alert.show(e.message);
      setLoader(false);
    }
  };

  const editSubs = async () => {
    try {
      setLoader(true);
      if (!userStore?.users?.user?._id) {
        alert.show("User not found");
      }
      const payload = {
        _id: userStore?.users?.user?._id,
      };
      const stripeRes = await api.editPayment(payload);
      console.log(stripeRes);

      if (!stripeRes?.link) {
        throw new Error("Something went wrong");
      }

      window.open(stripeRes?.link, "_blank");
      setLoader(false);
    } catch (e) {
      // No such subscription:
      console.log(e);
      alert.show(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (userStore?.users?.user?._id) {
      // checkSubs();
      setLoader(false);
    }
    setIsSubscription(SubsData?.isSubscription || false);
  }, [userStore?.users, SubsData]);

  const checkSubsStatus = async () => {
    try {
      setLoader(true);
      const stripeRes = await api.getSubscriptionStatus(
        userStore?.users?.user?.email
      );
      // console.log(stripeRes);
      if (stripeRes?.status) {
        setStripeStatus(stripeRes?.status);
      }

      setLoader(false);
    } catch (e) {
      console.log(e);

      alert.show(e.message);
      setLoader(false);
    }
  };

  const checkCanSubscribe = async () => {
    try {
      const stripeRes = await api.getCanSubscribe(
        userStore?.users?.user?.email
      );
      return stripeRes;
    } catch (e) {
      alert.show(e.message);
      setLoader(false);
    }
  };

  const getMarketTrend = async () => {
    try {
      const resp = await api.getMarketTrend();
      // console.log(resp);
      if (resp?.marketTrend?.trend_score) {
        setTrendData({
          trend_score: resp?.marketTrend?.trend_score,
          buy_pressure: resp?.marketTrend?.buy_pressure,
          sell_pressure: resp?.marketTrend?.sell_pressure,
        });
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    // console.log(userStore?.users?.user?.email);

    if (userStore?.users?.user?.email && SubsData?._id) {
      let currentDate = new Date();
      let endDate = new Date(SubsData?.nextPayment);
      if (currentDate > endDate) {
        checkSubsStatus();
      }
    }
    if (userStore?.users?.user?.email) {
      // getMarketTrend();
    }
  }, [userStore, SubsData]);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="contact-widget-area pb-70 subcribePage">
              <div className="contact-widget-area-inner">
                <div className="section-title  text-center mb-45">
                  <h2 className="">WE ARE AN EDUCATIONAL PLATFORM</h2>
                </div>
                <div className="investContent mx-auto mb-4">
                  <div className="mb-3">
                    <p className="mb-0">
                      🔹 Get exclusive access to our current investments in
                      crypto projects.
                    </p>
                    <p className="mb-0">
                      🔹 Track our portfolio performance and see what’s working.
                    </p>
                  </div>
                  <div className="mb-3">
                    <p className="mb-0">🔍 Where We Are Going to Invest</p>
                    <p className="mb-0">
                      🔹 Stay ahead with our future investment plans before
                      anyone else.
                    </p>
                    <p>
                      🔹 Leverage our in-depth market analysis and
                      research-backed decisions.
                    </p>
                  </div>
                  <div className="mb-3">
                    <p className="mb-0">📊 What You Get:</p>
                    <p className="mb-0">
                      ✅ Insider insights into top crypto projects.
                    </p>
                    <p className="mb-0">
                      ✅ Real-time investment strategies from experienced
                      traders.
                    </p>
                    <p className="mb-0">
                      ✅ Exclusive research reports on market trends and
                      opportunities.
                    </p>
                    <p className="mb-0">
                      ✅ Community discussions and expert opinions.
                    </p>
                  </div>
                  <div className="mb-3">
                    <p className="mb-0">
                      💳 Subscription Details: <b>10$ Monthly</b>
                    </p>
                    <p className="mb-0">
                      🔁 Monthly Recurring Subscription – You’ll be charged
                      automatically after <b>30 Days</b> completed.{" "}
                    </p>
                  </div>
                </div>
                <div className="checkCard contact-form signup-form">
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="email"
                      value={userStore?.users?.user?.email}
                      disabled
                    />
                  </div>
                  <div className="text-center">
                    {SubsData?._id &&
                      !loader &&
                      !SubsData?.unSubscribeReason && (
                        <>
                          {SubsData?.subscribeVia != "braintree" && (
                            <p>
                              Do you want to change your billing details or
                              retry payment?{" "}
                              <span onClick={editSubs} className="clickHere">
                                Click Here
                              </span>{" "}
                            </p>
                          )}
                        </>
                      )}
                    {isSubscription &&
                    !loader &&
                    !SubsData?.unSubscribeReason ? (
                      <>
                        {/* <p>
                    Do want to change your credit details{" "}
                    <span onClick={editSubs} className="clickHere">
                      click here
                    </span>{" "}
                  </p> */}
                        <button className="themeBtn w-100">
                          Already Subscribed
                        </button>
                      </>
                    ) : isSubscription && SubsData?.unSubscribeReason ? (
                      <>
                        <button className="themeBtn w-100">
                          Subscription is active till{" "}
                          {formatDate(SubsData?.nextPayment)}
                        </button>
                      </>
                    ) : SubsData?._id &&
                      !SubsData?.isSubscription &&
                      !loader &&
                      !SubsData?.unSubscribeReason &&
                      stripeStatus.includes("No subscription") ? (
                      <>
                        <button className="themeBtn w-100" onClick={handleShow}>
                          PAY NOW VIA STRIPE
                        </button>
                        {/* <BeforePayTermsBt /> */}
                      </>
                    ) : loader ? (
                      <button className="themeBtn w-100">
                        <i
                          className="fa fa-spinner fa-pulse mx-2 mb-1"
                          style={{ position: "relative", top: "-0px" }}
                        ></i>
                        loading
                      </button>
                    ) : SubsData?._id &&
                      !SubsData?.isSubscription &&
                      !loader &&
                      !SubsData?.unSubscribeReason ? (
                      <>
                        <button className="themeBtn w-100">
                          Recurring Payment Pending
                        </button>
                        <div className="mt-2 mb-4 text-center">
                          Do you want to cancel your Subscription?{" "}
                          <span
                            onClick={() => navigate("/subscription/history")}
                            className="clickHere"
                          >
                            Click Here
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <button className="themeBtn w-100" onClick={handleShow}>
                          PAY NOW VIA STRIPE
                        </button>
                        {/* <BeforePayTermsBt /> */}
                      </>
                    )}
                    {/* <Link className="themeBtn w-100" to="/dashboard">
                Click To Show
              </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BeforePayTerms
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        onStripePay={onStripePay}
      />
      <TextPopupModal
        show={showPopup}
        handleClose={handleClosePopup}
        text={popupText}
      />
    </>
  );
};
